<template>
	<v-card class="elevation-3 rounded-lg">
		<!-- Cabeçalho -->
		<v-card-title class="justify-center py-4">
			<span class="headline font-weight-medium secondary--text">
				<v-icon left color="secondary">mdi-clipboard-list</v-icon>
				Cadastro de Especialidade
			</span>
		</v-card-title>

		<v-divider />

		<!-- Conteúdo -->
		<v-card-text>
			<v-container grid-list-lg class="pt-2">
				<!-- STEP 1 - LISTAGEM -->
				<div v-if="step === 1">
					<div v-if="loadingList" class="text-center pa-4">
						<v-progress-circular indeterminate color="primary" />
					</div>

					<v-list two-line v-else class="rounded-lg elevation-1">
						<v-list-item
							v-for="esp in especialidades"
							:key="esp.id_especialidade || esp.id || esp.nome"
							class="hoverable"
						>
							<v-list-item-avatar color="secondary" size="36">
								<v-icon dark>mdi-stethoscope</v-icon>
							</v-list-item-avatar>

							<v-list-item-content>
								<v-list-item-title class="font-weight-medium">{{ esp.nome }}</v-list-item-title>
								<v-list-item-subtitle
									:class="esp.ativo ? 'green--text text--darken-2' : 'red--text text--darken-2'"
								>
									{{ esp.ativo ? 'Ativo' : 'Inativo' }}
								</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>

						<v-divider v-if="especialidades.length" />

						<v-list-item v-if="!especialidades.length">
							<v-list-item-content>
								<v-list-item-title class="text--disabled">Nenhuma especialidade carregada</v-list-item-title>
								<v-list-item-subtitle class="text--disabled">Sem itens retornados pela API</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</div>

				<!-- STEP 2 - CADASTRO -->
				<div v-else>
					<v-text-field
						v-model="nome"
						label="Nome da especialidade"
						outlined
						prepend-inner-icon="mdi-stethoscope"
						required
					/>

					<v-alert v-if="error" type="error" dense text class="mt-2">
						{{ error }}
					</v-alert>
				</div>
			</v-container>
		</v-card-text>

		<v-divider />

		<!-- Ações -->
		<v-card-actions class="justify-end pa-4">
			<v-btn color="error" text @click="fechar">
				<v-icon left>mdi-close</v-icon>
				Cancelar
			</v-btn>

			<v-spacer />

			<template v-if="step === 1">
				<v-btn color="primary" dark @click="irParaStep2">
					<v-icon left>mdi-plus</v-icon>
					Adicionar
				</v-btn>
			</template>

			<template v-else>
				<v-btn color="blue darken-2" text @click="voltar">
					<v-icon left>mdi-arrow-left</v-icon>
					Voltar
				</v-btn>

				<v-btn color="green darken-1" dark @click="cadastrar" :loading="loading">
					<v-icon left>mdi-check</v-icon>
					Confirmar
				</v-btn>
			</template>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	name: 'DialogEspecialidade',
	data () {
		return {
			step: 1,
			nome: '',
			loading: false,
			error: null,
			especialidades: [],
			loadingList: false
		}
	},
	mounted() {
		this.carregarEspecialidades()
	},
	methods: {
		fechar () {
			this.step = 1
			this.nome = ''
			this.error = null
			this.$emit('fechar')
		},
		irParaStep2 () {
			this.step = 2
		},
		voltar () {
			this.step = 1
			this.error = null
			this.carregarEspecialidades()
		},
		carregarEspecialidades () {
			this.loadingList = true
			this.error = null
			this.especialidades = []
			this.$store.dispatch('listarEspecialidades')
				.then((data) => {
					if (Array.isArray(data)) this.especialidades = data
					this.loadingList = false
					if (Array.isArray(this.especialidades) && this.especialidades.length === 0) {
						this.$emit('error', 'Nenhuma especialidade encontrada')
					}
				})
				.catch((err) => {
					this.loadingList = false
					this.error = (err && err.message) ? err.message : 'Erro ao carregar especialidades'
				})
		},
	cadastrar () {
      this.error = null
      if (!this.nome || !this.nome.trim()) {
        this.error = 'Informe o nome da especialidade'
        return
      }
      this.loading = true
      this.$store.dispatch('cadastrarEspecialidade', this.nome.trim())
        .then((data) => {
          this.loading = false
          this.$emit('salvo', data)
          this.step = 1
          this.nome = ''
         this.carregarEspecialidades()
         this.$emit('success', 'Especialidade cadastrada com sucesso!')
        })
        .catch((err) => {
          this.loading = false
          this.error = (err && err.message) ? err.message : (typeof err === 'string' ? err : 'Erro ao cadastrar')
        })
    },
	}
}
</script>

<style scoped>
.v-card {
	border-radius: 12px;
}
.v-list-item.hoverable:hover {
	background-color: rgba(0, 0, 0, 0.04);
	transition: background-color 0.2s ease;
}
.v-btn {
	text-transform: none !important;
}
</style>
